import dayjs from 'dayjs';
import UserStatCriteria from 'modules/Users/userStats/UserStatCriteria';
import { UserStat } from 'shared/model/statistic.model';
import { DATE_TIME_FORMAT } from 'utils/date-utils';

type Props = {
  stat: UserStat;
};

const UserStatConnection = ({ stat }: Props) => {
  const connectionDate = dayjs(stat.connection.date);
  const dateStr = connectionDate.format(DATE_TIME_FORMAT);

  return (
    <table className="user-stats">
      <tbody>
        <tr>
          <td className="font-bold">{dateStr}</td>
          <td>Connection</td>
          <td className="user-stat-content"></td>
        </tr>

        {stat.criteria.map(criteria => (
          <UserStatCriteria
            key={criteria.criteria.id}
            stat={criteria}
            sameDay={connectionDate.isSame(criteria.criteria.date, 'day')}
          />
        ))}
      </tbody>
    </table>
  );
};

export default UserStatConnection;
